export const selectedSeatsSelect = (state) => state?.pages?.hall?.movie?.selectedSeats ?? []
export const originalSeatingSelect = (state) => state?.pages?.hall?.seating?.originalSeating ?? []
export const basketSelector = (state) => state?.components?.basket?.data ?? null
